import { useContext, useState, useEffect } from 'react'
import _ from "lodash"

import { PassContext } from "../pass-context"
import dataSelector from './data-selector'
import PopupEditor from './popup-editor'

const LockScreen = () => {

  const { model, template, variables } = useContext(PassContext)

  const [imageSrc, setImageSrc] = useState(null)

  const iconPath = "meta.images.icon"
  const iconSrcUrl = dataSelector({ template, variables, path: iconPath })

  const organization_name = dataSelector({ template:model, variables, path: "organizationName" })

  useEffect(() => {
    if (!iconSrcUrl) return
    const img = new Image()
    img.crossOrigin = "anonymous"          // important for canvas/color picking
    img.onload = () => {
      setImageSrc(iconSrcUrl)
    }
    img.onerror = () => setImageSrc(null)
    img.src = iconSrcUrl                   // set after crossOrigin
  }, [iconSrcUrl])

  return (
    <div className="lock-screen" style={{backgroundColor:"white", color:"black"}}>
      <table width="100%">
        <tbody>
          <tr>
            <td valign="middle" width={75}>
              <PopupEditor title="Icon Image" path={iconPath}>
                <div className="image" style={{ position: "relative" }}>
                  <div style={{ position: "absolute", height:50, width:50, overflow:"hidden"}} className="editable" />
                  <img src={imageSrc} height={50} width={50} crossOrigin="anonymous"/>
                </div>
              </PopupEditor>
            </td>
            <td valign="middle">
              <PopupEditor title="Organisation name" path="organizationName" variable="pass.issuer_name">
                <div className='title editable overflow-hidden'>
                  {organization_name}
                </div>
              </PopupEditor>

              <div className='body'>notification message</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default LockScreen